import type { Locale } from '../../types'

/**
 * Maps a role identifier to its display name in Indonesian.
 *
 * @param role - The role identifier ('owner', 'admin', or 'member')
 * @returns The localized display name for the role
 *
 * @example
 * getRolesName('owner') // 'Pemilik'
 * getRolesName('admin') // 'Admin'
 * getRolesName('member') // 'Anggota'
 */
export function getRolesName(role: string, locale?: Locale): string {
  const localeFinal = locale ?? 'id'

  const normalized = role.toLowerCase().trim()
  if (normalized.includes('owner')) return localeFinal === 'id' ? 'Pemilik' : 'Owner'
  if (normalized.includes('admin')) return localeFinal === 'id' ? 'Admin' : 'Admin'
  if (normalized.includes('member')) return localeFinal === 'id' ? 'Anggota' : 'Member'
  return localeFinal === 'id' ? 'Anggota' : 'Member'
}
